import React, { useContext } from "react";
import { useParams } from "react-router-dom";

import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import ForumOutlinedIcon from "@material-ui/icons/ForumOutlined";

import KoraxConversationsManager from "../../components/KoraxConversationsManager";
import Ticket from "../../components/Ticket";

import {
  QueueSelectedProvider
} from "../../context/QueuesSelected/QueuesSelectedContext";

import { AuthContext } from "../../context/Auth/AuthContext";

import {
  getKoraxModeColors,
  koraxTokens
} from "../../designSystem";

const useStyles = makeStyles(theme => {
  const colors = getKoraxModeColors(theme.mode);
  const dark = theme.mode === "dark";

  return {
    page: {
      height: "calc(100vh - 56px)",
      padding: 8,
      boxSizing: "border-box",
      overflow: "hidden",
      backgroundColor: colors.background,

      [theme.breakpoints.down("sm")]: {
        padding: 0
      }
    },

    shell: {
      height: "100%",
      minHeight: 0,
      display: "grid",
      gridTemplateColumns: props =>
        `${props.sidebarWidth}px minmax(0, 1fr)`,
      gap: 8,

      [theme.breakpoints.down("sm")]: {
        display: "block"
      }
    },

    panel: {
      height: "100%",
      minWidth: 0,
      minHeight: 0,
      overflow: "hidden",
      borderRadius: 16,
      border: `1px solid ${colors.border}`,
      backgroundColor: colors.surface,
      boxShadow: koraxTokens.shadows.sm,

      [theme.breakpoints.down("sm")]: {
        borderRadius: 0,
        border: "none",
        boxShadow: "none"
      }
    },

    welcome: {
      height: "100%",
      minHeight: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 24,
      textAlign: "center",
      backgroundColor: colors.surface
    },

    welcomeInner: {
      width: "100%",
      maxWidth: 320,
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },

    welcomeIcon: {
      width: 62,
      height: 62,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 20,
      backgroundColor: dark
        ? "rgba(56,189,248,.10)"
        : koraxTokens.colors.primarySoft,
      color: theme.palette.primary.main,
      boxShadow: dark
        ? "none"
        : "0 10px 24px rgba(21,94,239,.10)",

      "& .MuiSvgIcon-root": {
        fontSize: 30
      }
    },

    welcomeTitle: {
      marginTop: 16,
      color: colors.textPrimary,
      fontSize: 19,
      fontWeight: 750,
      lineHeight: 1.25,
      letterSpacing: "-0.02em"
    },

    welcomeText: {
      marginTop: 7,
      color: colors.textMuted,
      fontSize: 13,
      lineHeight: 1.5
    },

    welcomeHint: {
      marginTop: 16,
      padding: "7px 11px",
      borderRadius: koraxTokens.radius.pill,
      border: `1px solid ${colors.border}`,
      backgroundColor: dark ? "#182230" : "#F8FAFC",
      color: colors.textSecondary,
      fontSize: 10.5,
      fontWeight: 600
    }
  };
});

const TicketsCustom = () => {
  const { user } = useContext(AuthContext);
  const { ticketId } = useParams();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const configuredWidth = Number(user?.defaultTicketsManagerWidth);
  const sidebarWidth =
    configuredWidth >= 320 && configuredWidth <= 430
      ? configuredWidth
      : 350;

  const classes = useStyles({ sidebarWidth });

  return (
    <QueueSelectedProvider>
      <div className={classes.page}>
        {isMobile ? (
          ticketId ? (
            <div className={classes.panel}>
              <Ticket />
            </div>
          ) : (
            <div className={classes.panel}>
              <KoraxConversationsManager />
            </div>
          )
        ) : (
          <div className={classes.shell}>
            <div className={classes.panel}>
              <KoraxConversationsManager />
            </div>

            <div className={classes.panel}>
              {ticketId ? (
                <Ticket />
              ) : (
                <Hidden only={["sm", "xs"]}>
                  <div className={classes.welcome}>
                    <div className={classes.welcomeInner}>
                      <div className={classes.welcomeIcon}>
                        <ForumOutlinedIcon />
                      </div>

                      <Typography className={classes.welcomeTitle}>
                        Nenhuma conversa selecionada
                      </Typography>

                      <Typography className={classes.welcomeText}>
                        Escolha um atendimento na coluna ao lado para abrir
                        o histórico e continuar a conversa.
                      </Typography>

                      <div className={classes.welcomeHint}>
                        Central de Conversas Korax
                      </div>
                    </div>
                  </div>
                </Hidden>
              )}
            </div>
          </div>
        )}
      </div>
    </QueueSelectedProvider>
  );
};

export default TicketsCustom;
